<!-- quotation-approve -->
<div class="common-popup-container reject-popup-wrapper accept-design-wrapper">
    <h3 class="title main-heading">{{ 'QUOTATIONNEW_SUMMARY.LBL_APPROVE_QUOTATION' | translate }}</h3>
    <p class="reject-text mt-2">{{ 'QUOTATIONNEW_SUMMARY.MSG_APPROVE_CONFIRMATION' | translate: { quotationId:
        data.quotationId } }}</p>

    <div class="my-input-group mt-4">
        <label for="">{{ 'QUOTATIONNEW_SUMMARY.LBL_COMMENT' | translate }}</label>
        <textarea name="" id="" [placeholder]="'QUOTATIONNEW_SUMMARY.PH_ENTER_COMMENT_OPTIONAL' | translate"
            [(ngModel)]="model.comment"></textarea>
    </div>
    <div class="d-flex justify-content-end cta-container mt-4">
        <button class="tertiary-cta mr-1" (click)="cancelClicked()">{{ 'QUOTATIONNEW_SUMMARY.LBL_CANCEL' | translate
            }}</button>
        <button class="primary-cta big" (click)="saveApproveQuotation()" [disabled]="isLoading">
            <span *ngIf="!isLoading">{{ 'QUOTATIONNEW_SUMMARY.LBL_APPROVE' | translate }}</span>
            <span *ngIf="isLoading">{{ 'QUOTATIONNEW_SUMMARY.LBL_APPROVING' | translate }}</span>
        </button>
    </div>
</div>

<div class="loader-overlay" *ngIf="isLoading">
    <div class="loader-container">
        <img src="assets/images/reload.svg" alt="">
        <span>{{'COMMON.LBL_LOADER' | translate}}</span>
    </div>
</div>